module.exports = __webpack_public_path__ + "7ed901ada46ff97b736743ab78d593b2.svg";